import { DefaultFooter } from '@ant-design/pro-layout';
import styles from './style.less';
import React, { useEffect, useState } from 'react';
import washokuLogo from '@/assets/logo9.svg';
import popsupLogo from '@/assets/popsuplogo.svg';
import { getMapStateToProps } from '@/utils/utils';
import joideaLogo from '@/assets/joidea-group-logo.svg';
import { Button, Modal } from 'antd';
import { connect } from 'dva';
import Link from 'umi/link';
import imageSettingByEnvs from '@/constants/ImageSettings';

const Footer: React.FC<any> = (props: any) => {
  const {
    helper: { tx },
    meta: { version },
    ca: { viewingBusinessId = undefined },
  } = props;

  const [showModal, setShowModal]: [boolean, any] = useState(false);
  const [title, setTitle]: [string, any] = useState('');

  const routeToUrl = (url: string) => {
    window.location.href = url;
  };

  const toggleShowModal = (key: 'terms' | 'privacy') => {
    setTitle(key);
    setShowModal(true);
  };

  const getTitle = () => {
    let renderTitle: string = '';
    if (title === 'terms') {
      renderTitle = 'Terms & Conditions';
    }
    if (title === 'privacy') {
      renderTitle = 'Privacy Policy';
    }
    return <div className="title">{renderTitle}</div>;
  };

  const linkKeyText = imageSettingByEnvs[POPSUP_WASHOKU_ONLY_SEVER_ENV_KEY || ''].logoText;
  const longLogo = imageSettingByEnvs[POPSUP_WASHOKU_ONLY_SEVER_ENV_KEY || ''].longLogo;
  const copyRight = imageSettingByEnvs[POPSUP_WASHOKU_ONLY_SEVER_ENV_KEY || ''].copyRightText;
  const redirectLink = imageSettingByEnvs[POPSUP_WASHOKU_ONLY_SEVER_ENV_KEY || ''].link;
  const termsAndConditions = imageSettingByEnvs[POPSUP_WASHOKU_ONLY_SEVER_ENV_KEY || ''].terms;
  const privacy = imageSettingByEnvs[POPSUP_WASHOKU_ONLY_SEVER_ENV_KEY || ''].privacy;

  return (
    <div className={styles.CustomerizedFooterContainer}>
      <DefaultFooter
        className={styles.CustomerizedFooter}
        links={[
          {
            key: linkKeyText,
            title: <img alt="logo" className={styles.footerPopsupLogo} src={longLogo} />,
            href: '/od',
          },
          // { key: '', title: '|', href: '' },
          // {
          //   key: 'JOIDEA',
          //   title: <img alt="logo" className={styles.footerJoideaLogo} src={joideaLogo} />,
          //   href: 'https://joidea.com',
          //   blankTarget: true,
          // },
        ]}
        copyright={copyRight}
      />
      {/* 展示version号码 */}

      <div>{`v${version}`}</div>

      <span className={styles.CustomerizedFooterLinks}>
        <Button type="link" onClick={() => routeToUrl(redirectLink)}>
          {/* {tx('Global.landing')} */}
          {imageSettingByEnvs[POPSUP_WASHOKU_ONLY_SEVER_ENV_KEY || ''].logoText}
        </Button>

        <Button type="link" onClick={() => toggleShowModal('terms')}>
          {tx('Global.terms_and_condition')}
        </Button>
        <Button type="link" onClick={() => toggleShowModal('privacy')}>
          {tx('Global.privacy_policy')}
        </Button>
      </span>

      <Modal
        title={getTitle()}
        visible={showModal}
        footer={null}
        onCancel={() => setShowModal(false)}
        style={{ top: 20 }}
        bodyStyle={{ paddingTop: '0' }}
        className={styles.modal}
      >
        {title === 'terms' && <div dangerouslySetInnerHTML={{ __html: termsAndConditions }} />}
        {title === 'privacy' && <div dangerouslySetInnerHTML={{ __html: privacy }} />}
      </Modal>
    </div>
  );
};

export default connect(getMapStateToProps(['meta', 'ca']))(Footer);
